import React, { useState } from "react";

type Slide = {
  image: string;
  title: string;
  subtitle: string;
};

const slides: Slide[] = [
  {
    image: "/images/pcl.png",
    title: "ACCESSORIES",
    subtitle: "For the perfect cigar ritual",
  },
  {
    image: "/images/rpr.png",
    title: "SUPER PREMIUM",
    subtitle: "The rarest of the rare",
  },
  {
    image: "/images/s84.png",
    title: "COLLECTION",
    subtitle: "Bring them together",
  },
  {
    image: "/images/s84m.png",
    title: "ACCESSORIES",
    subtitle: "For the perfect cigar ritual",
  },
  {
    image: "/images/v1925.png",
    title: "SUPER PREMIUM",
    subtitle: "The rarest of the rare",
  },
];

const CenterCarousel: React.FC = () => {
  const [current, setCurrent] = useState(0);

  const prevIndex = current === 0 ? slides.length - 1 : current - 1;
  const nextIndex = current === slides.length - 1 ? 0 : current + 1;

  const goNext = () => setCurrent(nextIndex);
  const goPrev = () => setCurrent(prevIndex);

  return (
    <div style={styles.wrapper}>
      <h2 className="title-collect">Our Cigar Collection</h2>

      <div style={styles.carousel}>
        {slides.map((slide, index) => {
          const total = slides.length;

          // Circular position calculation
          let position = index - current;

          if (position > total / 2) position -= total;
          if (position < -total / 2) position += total;

          const isCenter = position === 0;
          const isLeft = position === -1;
          const isRight = position === 1;

          // Only render nearby slides for performance
          if (Math.abs(position) > 2) return null;

          return (
            <div
              key={index}
              style={{
                ...styles.card,
                transform: `
          translateX(${position * 60}%)
          scale(${isCenter ? 1 : 0.85})
        `,
                opacity: isCenter ? 1 : 1,
                filter: isCenter ? "none" : "blur(2px) brightness(0.8)",
                zIndex: isCenter ? 3 : 1,
              }}
            >
              <img src={slide.image} style={styles.image} />

              {/* {isCenter && (
                <div style={styles.overlay}>
                  <h1 style={styles.title}>{slide.title}</h1>
                  <p style={styles.subtitle}>{slide.subtitle}</p>
                  <div style={{ marginTop: 20 }}>
                    <button style={styles.outlineBtn}>DISCOVER</button>
                    <button style={styles.goldBtn}>SHOP NOW</button>
                  </div>
                </div>
              )} */}
            </div>
          );
        })}

        <button style={styles.leftArrow} onClick={goPrev}>
          ‹
        </button>
        <button style={styles.rightArrow} onClick={goNext}>
          ›
        </button>
      </div>

      {/* Bottom Indicator Line */}
      <div style={styles.lineWrapper}>
        <div
          style={{
            ...styles.line,
            left: `${(current / slides.length) * 100}%`,
          }}
        />
      </div>
    </div>
  );
};

export default CenterCarousel;

/* ================== STYLES ================== */

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    width: "100%",
    padding: "0 0",
    textAlign: "center",
    margin: "0 auto",
    maxWidth: "1440px",
  },

  heading: {
    letterSpacing: "4px",
    marginBottom: "40px",
    fontWeight: 500,
  },

  carousel: {
    position: "relative",
    width: "100%",
    height: "405px",
    overflow: "hidden",
  },
  card: {
    position: "absolute",
    width: "55%",

    left: "22.5%",
    transition: "all 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
    borderRadius: "0",
    overflow: "hidden",
  },

  image: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    borderRadius: "0",
  },
  centerCard: {
    position: "absolute",
    width: "55%",
    height: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "0",
    transition: "all 0.5s ease",
    zIndex: 2,
  },

  sideCard: {
    position: "absolute",
    width: "35%",
    height: "85%",
    top: "7.5%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "0",
    filter: "blur(2px) brightness(0.7)",
    opacity: 0.8,
    cursor: "pointer",
    transition: "all 0.5s ease",
    zIndex: 1,
  },

  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    textAlign: "center",
  },

  title: {
    fontSize: "42px",
    letterSpacing: "3px",
  },

  subtitle: {
    fontSize: "18px",
    marginTop: "10px",
  },

  outlineBtn: {
    padding: "10px 25px",
    marginRight: "10px",
    background: "transparent",
    border: "1px solid #fff",
    color: "#fff",
    cursor: "pointer",
  },

  goldBtn: {
    padding: "10px 25px",
    background: "#c9a44d",
    border: "none",
    color: "#fff",
    cursor: "pointer",
  },

  leftArrow: {
    position: "absolute",
    top: "200px",
    left: "0",
    transform: "translateY(-50%)",
    background: "rgba(196, 152, 72,0.5)",
    border: "none",
    fontSize: "130px",
    padding: "5px 15px",
    borderRadius: "",
    cursor: "pointer",
    zIndex: 3,
    height: "calc(100% - 60px)",
    width: "100px",
    fontFamily: "Clarice",
    color: "#fff",
  },

  rightArrow: {
    position: "absolute",
    top: "200px",
    right: "0",
    transform: "translateY(-50%)",
    background: "rgba(196, 152, 72,0.5)",
    border: "none",
    fontSize: "130px",
    padding: "5px 15px",
    borderRadius: "",
    cursor: "pointer",
    zIndex: 3,
    height: "calc(100% - 60px)",
    width: "100px",
    fontFamily: "Clarice",
    color: "#fff",
  },

  lineWrapper: {
    width: "60%",
    height: "4px",
    background: "#ddd",
    margin: "40px auto 0",
    position: "relative",
  },

  line: {
    position: "absolute",
    height: "100%",
    width: "20%",
    background: "#c49848",
    transition: "left 0.5s ease",
  },
};
